import Axios from "./axios";

const resource = "key-assignments";

export default {
  create(data) {
		return Axios.post(`${resource}`, data);
	}
}